import * as React from 'react';

import Avatar from 'components/Avatar';

import type { AvatarSize } from 'components/Avatar';

type Props = {
  color?: 'mascot' | undefined | null | 'grey' | 'fullGrey' | 'whiteout';
  size?: AvatarSize;
  className?: string | null;
};

export default class GroupChatAvatar extends React.PureComponent<Props> {
  render() {
    const { color, size, className } = this.props;

    // @ts-expect-error ts-migrate(2322) FIXME: Type '"mascot" | "grey" | "fullGrey" | "whiteout" ... Remove this comment to see the full error message
    return <Avatar color={color} size={size} className={className} glyphName="message-group" />;
  }
}
